import React, {useMemo} from "react";
import {Avatar, SvgIcon} from "@material-ui/core";
import EmojiTransportationIcon from '@material-ui/icons/EmojiTransportation';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import * as c from "../../../constants";

export const MinusSquare = (props) => (
    <ExpandLessIcon fontSize="inherit" style={{width: 20, height: 20}} {...props}/>
);

export const PlusSquare = (props) => (
    <ExpandMoreIcon fontSize="inherit" style={{width: 20, height: 20}} {...props}/>
);

export const FacilityIcon = (props) => (
    <>
        <EmojiTransportationIcon {...props}/>
    </>
);

export const TenantAndValetIcon = (props) => (
    <SvgIcon {...props}>
        {/* tslint:disable-next-line: max-line-length */}
        <path
            d="M17,11V3H7v4H3v14h8v-4h2v4h8V11H17z M7,19H5v-2h2V19z M7,15H5v-2h2V15z M7,11H5V9h2V11z M11,15H9v-2h2V15z M11,11H9V9h2 V11z M11,7H9V5h2V7z M15,15h-2v-2h2V15z M15,11h-2V9h2V11z M15,7h-2V5h2V7z M19,19h-2v-2h2V19z M19,15h-2v-2h2V15z"/>
    </SvgIcon>
);

export const AreaIcon = (props) => (
    <SvgIcon {...props}>
        {/* tslint:disable-next-line: max-line-length */}
        <path
            d="M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z"/>
    </SvgIcon>
);

export const FacilityGroupIcon = (props) => (
    <SvgIcon {...props}>
        {/* tslint:disable-next-line: max-line-length */}
        <path d="M22,21V7L12,3L2,7v14h5v-9h10v9H22z M11,19H9v2h2V19z M13,16h-2v2h2V16z M15,19h-2v2h2V19z"/>
    </SvgIcon>
);

export const DeviceIcon = (props) => (
    <SvgIcon {...props}>
        {/* tslint:disable-next-line: max-line-length */}
        <path
            d="M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"/>
    </SvgIcon>
);

export const EntityTypeIcons = props => {
    const {entityType} = props

    return useMemo(() => {
        switch (entityType) {
            case c.ENTITY_TYPE.Device:
                return <DeviceIcon {...props} />;
            case c.ENTITY_TYPE.Facility:
                return <FacilityIcon {...props} />;
            case c.ENTITY_TYPE.Area:
                return <AreaIcon {...props} />;
            case c.ENTITY_TYPE.ValetArea:
                return <TenantAndValetIcon {...props} />;
            case c.ENTITY_TYPE.Tenant:
                return <TenantAndValetIcon {...props} />;
            case c.ENTITY_TYPE.FacilityGroup:
                return <FacilityGroupIcon {...props} />;
            default:
                return <DeviceIcon/>;
        }
    }, [entityType]);
}

export const ChildrenNumberIcon = props => {
    const {entities, entityID} = props

    const childrenLength = useMemo(() => entities.length, [entityID]);

    return (
        <Avatar  {...props} > {childrenLength}</Avatar>
    )
};